import React from 'react';
import PropTypes from 'prop-types';

import './EmployerLogos.scss';

import CardHeader from '../../../Groups/CardHeader/CardHeader';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import { IMAGE_CDN_URL } from '../../../../utilities/imageCDN';

export default class EmployerLogos extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        companies: PropTypes.arrayOf(
            PropTypes.shape({
                companyId: PropTypes.number.isRequired,
                url: PropTypes.string.isRequired,
                logo: PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.string,
                }).isRequired,
            })
        ).isRequired,
    };

    handleClick = (companyId) => () => {
        EmitMetric({
            misc_event_type: 'employer-marketing-company-logo-click',
            misc_event_count: 1,
            company_id: companyId,
        });
    };

    renderEmployerLogos = ({ companyId, url, logo }, index) => {
        return (
            <li onClick={this.handleClick(companyId)} key={`logo-${index}`}>
                <a href={url}>
                    <img
                        src={`${IMAGE_CDN_URL}/c_lpad,w_120,h_50/${logo.src}`}
                        alt={logo.alt}
                        className="employer-logo"
                    />
                </a>
            </li>
        );
    };

    render() {
        return (
            <div className="component-Employer-Marketing-EmployerLogos">
                <CardHeader>
                    We're Proud To Work With Hundreds Of Top Employers
                </CardHeader>
                <ul>{this.props.companies.map(this.renderEmployerLogos)}</ul>
            </div>
        );
    }
}
